/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StockAdjustDetailResVo
 */
export interface StockAdjustDetailResVo {
    /**
     * 调整记录编号
     * @type {string}
     * @memberof StockAdjustDetailResVo
     */
    adjustRecordNo?: string;
    /**
     * 调整数量（正数增加，负数减少）
     * @type {number}
     * @memberof StockAdjustDetailResVo
     */
    adjustedQty?: number;
    /**
     * 调整原因编码，见 StockAdjustReasonEnum
     * @type {number}
     * @memberof StockAdjustDetailResVo
     */
    adjustReasonCode?: number;
    /**
     * 调整原因（按当前语言）
     * @type {string}
     * @memberof StockAdjustDetailResVo
     */
    adjustReason?: string;
    /**
     * 操作员
     * @type {string}
     * @memberof StockAdjustDetailResVo
     */
    operatorName?: string;
    /**
     * 调整前数量
     * @type {number}
     * @memberof StockAdjustDetailResVo
     */
    beforeAdjustQuantity?: number;
    /**
     * 调整后数量
     * @type {number}
     * @memberof StockAdjustDetailResVo
     */
    afterAdjustQuantity?: number;
    /**
     * 调整批次（库存订单号）
     * @type {string}
     * @memberof StockAdjustDetailResVo
     */
    batchNo?: string;
    /**
     * 货位号，格式：货位/唛头
     * @type {string}
     * @memberof StockAdjustDetailResVo
     */
    locationNo?: string;
    /**
     * 调整时间
     * @type {string}
     * @memberof StockAdjustDetailResVo
     */
    adjustTime?: string;
}

/**
 * Check if a given object implements the StockAdjustDetailResVo interface.
 */
export function instanceOfStockAdjustDetailResVo(value: object): value is StockAdjustDetailResVo {
    return true;
}

export function StockAdjustDetailResVoFromJSON(json: any): StockAdjustDetailResVo {
    return StockAdjustDetailResVoFromJSONTyped(json, false);
}

export function StockAdjustDetailResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): StockAdjustDetailResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'adjustRecordNo': json['adjustRecordNo'] == null ? undefined : json['adjustRecordNo'],
        'adjustedQty': json['adjustedQty'] == null ? undefined : json['adjustedQty'],
        'adjustReasonCode': json['adjustReasonCode'] == null ? undefined : json['adjustReasonCode'],
        'adjustReason': json['adjustReason'] == null ? undefined : json['adjustReason'],
        'operatorName': json['operatorName'] == null ? undefined : json['operatorName'],
        'beforeAdjustQuantity': json['beforeAdjustQuantity'] == null ? undefined : json['beforeAdjustQuantity'],
        'afterAdjustQuantity': json['afterAdjustQuantity'] == null ? undefined : json['afterAdjustQuantity'],
        'batchNo': json['batchNo'] == null ? undefined : json['batchNo'],
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
        'adjustTime': json['adjustTime'] == null ? undefined : json['adjustTime'],
    };
}

export function StockAdjustDetailResVoToJSON(json: any): StockAdjustDetailResVo {
    return StockAdjustDetailResVoToJSONTyped(json, false);
}

export function StockAdjustDetailResVoToJSONTyped(value?: StockAdjustDetailResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'adjustRecordNo': value['adjustRecordNo'],
        'adjustedQty': value['adjustedQty'],
        'adjustReasonCode': value['adjustReasonCode'],
        'adjustReason': value['adjustReason'],
        'operatorName': value['operatorName'],
        'beforeAdjustQuantity': value['beforeAdjustQuantity'],
        'afterAdjustQuantity': value['afterAdjustQuantity'],
        'batchNo': value['batchNo'],
        'locationNo': value['locationNo'],
        'adjustTime': value['adjustTime'],
    };
}

